import { useEffect }        from 'react'
import { useFetch }         from 'hooks/fetch/useFetch'
import { get, getFocus, setFocus, useGet } from 'state/jotai'
import { renderLayout }     from 'state/store.global'
import { preloadImage }     from 'utilities/utility.images'
import eachOfLimit          from 'async/eachOfLimit'
import { _parentIsometry } from 'state/store.parentIsometry'
import { ISOPARENT_CONFIG } from 'api/api'

export const PreloadFramesParent_Tiny = () => {
  const file     = 'PreloadingTiny.jsx'
  const url      = ISOPARENT_CONFIG
  const config   = useFetch({ url, file }).D
  const ready    = useGet(renderLayout)
  const setTiny  = setFocus(_parentIsometry, 'tiny')
  const setFrame = setFocus(_parentIsometry, 'activeframe')
  const setMode  = setFocus(_parentIsometry, 'mode')
  const isometryToggle     = get(_parentIsometry, 'toggle');

  useEffect(()=>{
    if ( isometryToggle && config && ready ) {
      const len = config.length
      const arr = []
      const ini = []
      const mod = []
      
      eachOfLimit(config, len, 
        ( val, idx, callback ) => {
          const IMG = preloadImage(val.TINY)
          const PID = val.PROJECT_ID
          
          const INI = val.SLIDER_INITIAL
          arr[idx] = ({[PID]:IMG})
          ini[idx] = ({[PID]:INI})
          mod[idx] = ({[PID]:true})
          setTiny( arr )
        
          setFrame( ini )
          setMode( mod )
          IMG.onload = () => callback()
        },
        () => {
          // console.log( 'Done preloading tiny frames' )
        }
      )
    }
  },[config, ready])
  return null
}